// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"ZP-z","carouselContainer":"_P-z"};